module.exports = __webpack_public_path__ + "static/media/HighGuardianOfAether06.748a7cfe.jpg";